import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';

export const isInPreviewMode = createSelector(
  (state: RootState) => state.application.insertingObjectInfo,
  (insertingObjectInfo) => {
    if (insertingObjectInfo && insertingObjectInfo.type === 'componentDesign') {
      const { loadedInfo } = insertingObjectInfo;
      return loadedInfo.isLoaded;
    }
    return false;
  },
);
